import React, { useEffect } from 'react';
import { MainTable } from '../../Components/MainTable/MainTable';
import { useSlider } from './SliderStore';
import Add from './Add';
import Edit from './Edit';

function MainSlider(props) {
    const { slider, getSlider, columns, deleteSlider, editSlider, setEd } = useSlider();
    useEffect(() => {
        getSlider();
    }, []);
    return (
        <MainTable 
            pageTitle={'Asosiy Slayder'}
            pdata={slider}
            defkey={'id'}
            pcolumns={columns}
            add={<Add />}
            edit={<Edit />}
            onDelete={(_, rec) => deleteSlider(rec)}
            onEdit={(rec) => {
                setEd(rec)
            }}
            setEd={setEd}
            editBtn={true}
            deleteBtn={true}
            edw={'760px'}
            adw={'760px'}
        />
    );
}

export default MainSlider;